import { Component, OnInit, AfterViewInit, Input } from '@angular/core';
import { Richtext } from 'dhx-richtext';
import { Router, ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { MailFieldsService } from '../../Master/mailfields/mailfields.service';
import { FormGroup, Validators, FormBuilder, FormControl } from '@angular/forms';
import { CommondialogComponent } from '../../Shared/commondialog/commondialog.component';
import { DialogService } from 'ng2-bootstrap-modal';
import { UserService } from '../../Master/user/user.service';
import { MailgroupService } from '../../mailgroup/mailgroup.service';
import { HelpdeskComponent } from '../../Shared/helpdesk/helpdesk.component';
import { MailTemplateService } from '../../Template/mailtemplate/mailtemplate.service';
import { MailTemplate } from '../../Template/mailtemplate/mailtemplate';
import { MailConfig } from '../../configuration/mailconfig/mailconfig';
import { NewsletterService } from './newsletter.service';
import { DatabaseService } from '../../Master/database/database.service';

import { BsModalService, ModalOptions, BsModalRef } from 'ngx-bootstrap';
import { NgxSpinnerService } from "ngx-spinner";
import { LocalService } from '../../local.service';
import {encryptdecrypt} from '../../encryptdecrypt';
@Component({
  selector: 'app-newsletter',
  templateUrl: './newsletter.component.html',
  styleUrls: ['./newsletter.component.css']
})
export class NewsletterComponent implements OnInit {
  public richtext: any; userid: number;
  _mailGroupListtmp: any = []; _mailGroupList: any = []; public _metaFieldsList: any;
  _dropdownSettings: any; action: string;
  _toMailDropdownSettings: any; _userMailList: any = []; _selectedItems: any = [];
  _toMailList: any = []; _ccMailList: any = []; _mailTempList: any = []; _selectedMailTemplate: any = []; _selectedToIds: any = []; _selectedCcIds: any = [];
  _toTemplateDropdownSettings: any; _templateList: any = []; p: number = 1; itemsPerPage: number = 10; public searchText: string; confmsg: string; msg: string;
  _groupMapped: any = []; _toMailIdMapped: any[]; _ccMailIdMapped: any[]; formTocuhed: boolean;
  _mailConfigList: any = [];
  _mailConfigListactive: any = [];
  _mailConfigListTmp: any[]; currentMailConfig: string;
  _mailConfigid: any; _mailTemplateId: number; databases: any = []; selectedDb: boolean; public queryStrDb: any; hideDiv: boolean;
  _menuId: any
  //menu rights defining buttons
  _actionRights: any; submitShow: boolean;
  readOnly: boolean; add: boolean; edit: boolean; delete: boolean;
  events: any[] = [];
  selectedevent: any = 0; selectevent: boolean = false; requestTypes: any[] = [];
  labeltext: string = null; formConfigList: any[] = [];
  showall: boolean = true;
  showallstatus: boolean = false;
  formconfigddl: boolean = false; requesttypeddl: boolean = false
  tempFormConfigList = [];
  scheduledtabshow: boolean = false; showtimepicker: boolean = false; showhourpicker: boolean = false;// showtimepicker: boolean = false;
  schedulespecifictime: any;
  scheduleinterval: any;
  scheduletypeedit: string = '';
  scheduledaysedit: any = [];
  _mailConfigListTmpsave: MailConfig;
  _mailConfigListTmpedit: MailConfig;
  public _metaFieldsListSelect: any; public eventtype: number;
  _formData: any
  selectedrequest: any = 0; selectedform: any = 0;
  formConfigListSelect: any[] = [];
  formdetails: string='';  
  @Input() formconfigid: string;
  @Input() dbid: string;
  @Input() dbname: string;

  constructor(private MailFields: MailFieldsService,
    private toastr: ToastrService,
    private formBuilder: FormBuilder,
    private dialogService: DialogService, private mailgroupService: MailgroupService, private userService: UserService,
    private route: ActivatedRoute, private router: Router,
    private mailTemplateSer: MailTemplateService, private mailConfigSer: NewsletterService,
    private databaseservice: DatabaseService, public bsModalRef: BsModalRef, 
    private SpinnerService: NgxSpinnerService, private localService: LocalService) { }
  mailconfigForm: FormGroup;
 
  mailConfigs: MailConfig[];
  mailConfig: MailConfig;
  //mail template array
  mailTemps: MailTemplate[];
  submitted = false;
  ngOnInit() {
   
      this.mailconfigForm = this.formBuilder.group(
        {
         
          subject: ['', Validators.required],
          tomailid: [''], ccmailid: [''], mailgroups: ['']                  
        });

    this.hideDiv = true;
    this.searchText = '';
    this.action = 'update';
    this.scheduledtabshow = false;
    this.formTocuhed = false;
    
    this.Loadusermaillist();
   
    this.Loadmailfieldsvaluelist();

    this.Loadmailgrouplist();

    this._selectedMailTemplate = [];
    this._selectedToIds = [];
    this._selectedCcIds = [];
    this._selectedItems = [];
    this._mailConfigListTmp = [];
    this._mailConfigList = [];
   
    this.currentMailConfig = '';
    this._mailConfigid = '';
    this._mailTemplateId = 0;  
    this.databases = [];
    //by default assigning value from menu rights button
    this.add = false;
    this.edit = false;
    this.delete = false;
    this.submitShow = false;
    
  }

  key: string = 'mailconfigname'; //set default
  reverse: boolean = false;
  sort(key) {
    this.key = key;
    this.reverse = !this.reverse;
  }
  get formdata() { return this.mailconfigForm.controls; }


  LoadMailConfigList() {
    this._mailConfigList = [];
    this._mailConfigListactive = [];
    this.mailConfigSer.Get().subscribe(
      (res) => {
        if (res != undefined) {
          this._mailConfigListTmp = [];
          this._mailConfigList = [];
          this._mailConfigList = res;
          var allData = res;
          this._mailConfigListTmp = res;
          //this._mailConfigListTmpedit = this._mailConfigList.find(item => item.formconfigid == this.formconfigid);
          this._mailConfigListTmpedit = this._mailConfigList.find(item => item.eventid == 16);
          allData.forEach(data => {
            this._mailConfigList.push({ mailconfigid: data.mailconfigid, mailconfigname: data.mailconfigname, active: data.active })
          });
          this.editMailConfig();
        }
      });
  }

  //load the meta fields value details in the list from services
  Loadmailfieldsvaluelist() {
    this.MailFields.Get().subscribe(res => {
      //console.log(res);
      this._metaFieldsList = res;
      this.LoadRichtextBox();
    }, error => { this.toastr.error('Error while getting the mail fields data') });
  }
  
  //load richtextbox control
  LoadRichtextBox() {

    this.richtext = new Richtext("richtext_container", {
      mode: "classic", toolbarBlocks: ["default"]
    });
    this.richtext.toolbar.data.remove("link");

    this._metaFieldsListSelect = this._metaFieldsList.filter(item => item.type == 1);
    for (var i = 0; i < this._metaFieldsListSelect.length; i++) {
      var _value = this._metaFieldsListSelect[i]['mailfields'];
      var _id = this._metaFieldsListSelect[i]['mailfieldsvalues'];
      this.richtext.toolbar.data.add(
        {
          type: "button",
          value: _value,
          id: _id
        }, i + 24);
    }


    var EditorAPI = this.richtext.getEditorAPI();
    this.richtext.toolbar.events.on("click", function (id, event) {
      //console.log(EditorAPI.getModel());
      if (id.startsWith('$$')) {
        EditorAPI.add(id);
      }
      event.preventDefault();
    });
    this.richtext.toolbar.events.on('selectionRefresh', function (event) {
      event.preventDefault();
    });

  }

  //to get the individual user mail list 
  Loadusermaillist() {
     let a= new encryptdecrypt(); 
    this.userService.Get().subscribe(
      res => {
          res.forEach((data: any) => {
        data.firstname = a.decryptUsingAES256(data.firstname);
        data.lastname = a.decryptUsingAES256(data.lastname);
        data.emailid = a.decryptUsingAES256(data.emailid);
      });
        var allData = res;
        allData.forEach(data => {
          if (data.active != 0) {
            this._userMailList.push({ userid: data.userid, emailid: data.emailid });
          }
        });
        this._toMailDropdownSettings = {
          singleSelection: false,
          idField: 'userid',
          textField: 'emailid',
          selectAllText: 'Select All',
          unSelectAllText: 'UnSelect All',
          itemsShowLimit: 7,
          allowSearchFilter: true,
          enableCheckAll: true
        };
        this._toMailList = JSON.parse(JSON.stringify(this._userMailList));
        this._ccMailList = JSON.parse(JSON.stringify(this._userMailList));
        this.LoadMailConfigList();
      }, error => { this.toastr.error('Error in getting user mail list'); }
    )
  }

  clearForm() {
    this.submitted = false;
    this.action = 'update';
    this._selectedToIds = [];
    this._selectedCcIds = [];
    this._selectedItems = [];
    this._selectedMailTemplate = [];
    this.scheduledtabshow = false;
    this.mailconfigForm.reset();
    this.scheduletypeedit = '';
    this.richtext.setValue('');
    this.currentMailConfig = '';
    this.scheduledtabshow = false;
    this._mailConfigid = '';
    this._mailTemplateId = 0;
    this.mailconfigForm.controls['tomailid'].setValue(this._selectedToIds);
    this.mailconfigForm.controls['ccmailid'].setValue(this._selectedCcIds);
    this.mailconfigForm.controls['mailgroups'].setValue(this._selectedItems);

    this.formconfigddl = false; this.requesttypeddl = false;
    this.formTocuhed = false;
    if (this.add == true)
      this.submitShow = true;
    else
      this.submitShow = false;
    this.selectedDb = true;
    this.queryStrDb = 0;
    this.mailconfigForm.value.dbid = 0;
    this.hideDiv = true;
    this.bsModalRef.hide();
  }
  Loadmailgrouplist() {
    this.mailgroupService.getmailgroups().subscribe(res => {
      if (res != undefined) {
        //console.log(res);
        var allData = res;
        allData.forEach(data => {
          if (data.active != 0) {
            this._mailGroupListtmp.push({ mailgroupid: data.mailgroupid, mailgroup: data.mailgroup });
          }
        });
        this._dropdownSettings = {
          singleSelection: false,
          idField: 'mailgroupid',
          textField: 'mailgroup',
          selectAllText: 'Select All',
          unSelectAllText: 'UnSelect All',
          itemsShowLimit: 7,
          allowSearchFilter: true
        };
        this._mailGroupList = JSON.parse(JSON.stringify(this._mailGroupListtmp));
      }
    }, error => { this.toastr.error('Error in getting group mail list'); }

    )


  };



  //form valid mail structure suit for  multi select list
  formMultiSelectStrucuture(mappedList, mailList, type) {
    var tempList = [];
    if (type == 'mailgroup') {
      if ((mappedList != null) && (mappedList.length != 0)) {
        mailList.forEach((d) => {
          mappedList.forEach((data, ind) => {
            if (data.mailgroupid == d.mailgroupid) {
              tempList.push({
                mailgroupid: d.mailgroupid, mailgroup: d.mailgroup
              });
            }
          });
        });
      }
    }
    if (type == 'user') {
      if ((mappedList != null) && (mappedList.length != 0)) {
        mailList.forEach((d) => {
          mappedList.forEach((data, ind) => {
            if (data.userid == d.userid) {
              tempList.push({
                userid: d.userid, emailid: d.emailid
              });
            }
          });
        });
      }
    }

    mappedList = [];
    mappedList = tempList;
    return tempList;
  }

  //validate the mail id from mail template
  validateMailIds(mailTemp, activeList, type) {
    var tempList = [];
    if (type == 'mailgroup') {
      if ((mailTemp != null) && (mailTemp.length != 0)) {
        activeList.forEach((d) => {
          mailTemp.forEach((data, ind) => {
            if (data.mailgroupid == d.mailgroupid) {
              tempList.push({
                mailgroupid: d.mailgroupid, mailgroup: d.mailgroup
              });
            }
          });
        });

      }
    }
    if (type == 'user') {
      if ((mailTemp != null) && (mailTemp.length != 0)) {
        activeList.forEach((d) => {
          mailTemp.forEach((data, ind) => {
            if (data.userid == d.userid) {
              tempList.push({
                userid: d.userid, emailid: d.emailid
              });
            }
          });
        });
      }
    }
    mailTemp = [];
    mailTemp = tempList;
    return tempList;
  }

 
  //add or update the mail configuration details in the database
  saveMailConfig(operation) {
    this.SpinnerService.show();
    var _groupText = {}; var _mailToIds = {}; var _mailCcIds = {};
    this.submitted = true;
    //this.userid = +localStorage.getItem('userid');
    this.userid = +this.localService.getJsonValue('userid');
    var mailContentTxt = this.richtext.getValue("html");
    var validmailContentTxt = this.richtext.getValue("markdown");
    this.mailconfigForm.value.dbid = this.queryStrDb;

    if (this.mailconfigForm.valid) {

      if (this.mailconfigForm.value.subject.trim() == null || this.mailconfigForm.value.subject.trim() == '') {
        this.toastr.error('Subject should not be empty');
        return;
      }

      if ((mailContentTxt.trim() == undefined) || (mailContentTxt.trim() == '') || (mailContentTxt.trim() == '<p></p>') || (validmailContentTxt.trim() == '')) {
        this.toastr.error('Mail content is required');
        return;
      }
      _groupText['mailgroups'] = this.mailSaveStructure(this._selectedItems, 'mailgroup');//this._selectedItems
      _mailToIds['mailto'] = this.mailSaveStructure(this._selectedToIds, 'user');//this._selectedToIds;
      _mailCcIds['mailcc'] = this.mailSaveStructure(this._selectedCcIds, 'user');//this._selectedCcIds;
      this._groupMapped = []; this._toMailIdMapped = []; this._ccMailIdMapped = [];
      //this.mailconfigForm.value.groupmapped = JSON.stringify(_groupText);
      this.mailconfigForm.value.mailto = JSON.stringify(_mailToIds);
      this.mailconfigForm.value.mailcc = JSON.stringify(_mailCcIds);
      this.mailconfigForm.value.mailcontent = mailContentTxt;
      this.mailconfigForm.value.mailtemplateid = this._mailTemplateId;
      if ((mailContentTxt.trim() != undefined) || (mailContentTxt.trim() != '') || (mailContentTxt.trim() == '<p></p>')) {
        //to add new mail config information        
        if (operation == 'update') {
          this._mailConfigListTmpsave = this._mailConfigListTmp.find(item => item.eventid == 16);
          this._mailConfigListTmpsave.mailto = JSON.stringify(_mailToIds);
          this._mailConfigListTmpsave.mailcc = JSON.stringify(_mailCcIds);
          this._mailConfigListTmpsave.mailcontent = mailContentTxt;
          this._mailConfigListTmpsave.formconfigid = +this.formconfigid;
          this._mailConfigListTmpsave.modifiedby = this.userid;

          this.mailConfigSer.Put(this._mailConfigListTmpsave).subscribe(
            (res) => {
              if (res.body.message == 'success') {
                this.toastr.success('Mail Sent Successfully');
                this.LoadMailConfigList();
                this.clearForm();
                this.SpinnerService.hide();
              }
              else {
                this.toastr.error(res.message);
                this.SpinnerService.hide();}
            }, error => {
              this.toastr.error(error); console.log(error);
              this.SpinnerService.hide();
            });
        }
      }
      else {
        this.toastr.error('Mail content should not be empty');
        this.SpinnerService.hide();
      }
    }
  }

  //forming the json structure before saving
  mailSaveStructure(list, type) {
    var temp = [];
    if (type == 'mailgroup') {
      if (list.length > 0) {
        list.forEach(item => {
          temp.push({ mailgroupid: item.mailgroupid })
        })
      }
    }
    if (type == 'user') {
      if (list.length > 0) {
        list.forEach(item => {
          temp.push({ userid: item.userid })
        })
      }
    }
    return temp;
  }

  //click event for edit icon in the grid
  editMailConfig() {
    this.SpinnerService.show();
    this.mailConfigSer.Getformdetailsfornewsletter(this.dbid, this.dbname, this.formconfigid).subscribe(
      (res) => {
        if (res != undefined) {
          this.formdetails = res.message;
          // this.formdetails = this.formdetails.replace("<p style='color:red;'> NEW ! </p><p>","<p><p style='color:red;'> NEW ! </p>")
          console.log(this.formdetails);
          if (this._mailConfigListTmp.length != 0) {

            this.richtext.setValue(this.formdetails);
            this._mailConfigid = this._mailConfigListTmpedit.mailconfigid;
            this.mailconfigForm.controls['subject'].setValue(this._mailConfigListTmpedit.subject);
            if (JSON.parse(this._mailConfigListTmpedit.groupmapped) != null) {
              this._selectedItems = this.formMultiSelectStrucuture((JSON.parse(this._mailConfigListTmpedit.groupmapped)).mailgroups, this._mailGroupListtmp, 'mailgroup');
              //(JSON.parse(s[0].groupmapped)).mailgroups;
            }
            else
              this._selectedItems = [];

            if (JSON.parse(this._mailConfigListTmpedit.mailto) != null)
              this._selectedToIds = this.formMultiSelectStrucuture((JSON.parse(this._mailConfigListTmpedit.mailto)).mailto, this._userMailList, 'user');
            else
              this._selectedToIds = [];
            if (JSON.parse(this._mailConfigListTmpedit.mailcc) != null)
              this._selectedCcIds = this.formMultiSelectStrucuture((JSON.parse(this._mailConfigListTmpedit.mailcc)).mailcc, this._userMailList, 'user')
            else
              this._selectedCcIds = [];

          }

        }
        this.SpinnerService.hide();
      }, error => {
        this.toastr.error(error); console.log(error);
        this.SpinnerService.hide();
      });


  }

  
  close() {   
    this.bsModalRef.hide();
  }

  onItemSelect(item: any) {
    this.formTocuhed = true;
  }
  onItemDeSelect(item: any) {
    this.formTocuhed = true;
  }
  touched() {
    this.formTocuhed = true;
  }

  onCCmailidSelect(item: any) {
    this.formTocuhed = true;
  }
}
